export default {
  isSet () {
    return this.ready.state === 'set'
  },
  setSubscriptions () {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'graphics/getAllComplete') {
        /**
         * Sync is already called in the created() chain. Dont call twice at init.
         */
        if (this.isSet()) {
          this.syncGraphics()
        }
      }
      if (
        mutation.type === 'graphics/remove' ||
        mutation.type === 'graphics/uploadComplete'
      ) {
        this.syncGraphics()
          .then(this.updateSubmission)
        /**
         * Tell Expand to re-calculate.
         */
        this.$events.$emit('fou:expand:update')
      }
    })
  },
  buildSubmission () {
    /**
     * Set imageSortorders.
     */
    const _getIds = (order) => {
      /**
       * Temp fake for countries:
       * Always add min 5 ids in case, ISO is not default.
       */
      let ids = order.graphics.map(g => g.image.id)
      if (order.iso !== this.$store.getters['settings/iso']) {
        ids = ['123', '456', '789', '012', '345']
      }
      return ids
    }
    const orders = this.sortOrders.map(order => {
      return {
        locationIso: order.iso,
        imageIds: _getIds(order).filter(o => o !== null)
      }
    })
    this.submissionImageSortorders = orders
  },
  posterPlaceholders (order) {
    const minSlides = this.minSlides * 1
    const graphicsLen = order.graphics.length
    return (minSlides - graphicsLen) > 0
      ? Array(minSlides - graphicsLen)
      : []
  },
  updatePoster () {
    this.fouDraggable.update(() => {
      this.updateSubmission()
    })  
  }
}
